import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import useModalContext from './useModalContext';

/**
*/
export default function Item({ id, children, className }) {
  const { current } = useModalContext();
  return (
    <div className={cns('v2-modal__item', { 'v2-modal__item--hidden': current !== '__only_one_child__' && id !== current }, className)}>
      {children}
    </div>
  );
}

Item.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Contenuto da renderizzare all'interno del componente.
 */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * Identificativo dell'item.
   */
  id: PropTypes.string.isRequired,
};

Item.defaultProps = {
  className: undefined,
  children: undefined,
};
